import {
    mobileOnly, tabletLandscapeUp, tabletPortraitUp, desktopUp, smallMobile
} from '@styles/breakpoints';
import colors from '@styles/colors';
import { css } from '@emotion/css'

export default {
    personalizedContainer: css({
        backgroundColor: colors.BEIGE_OVERVIEW,
        padding: 30,
        borderRadius: 7,
        marginBottom: 60,
        [mobileOnly]: {
            borderRadius: 0,
            padding: 24,
        },
        [tabletPortraitUp]: {
            borderRadius: 0,
            padding: 24,
        },
        '.personalized-header': {
            color: colors.NAVY,
            fontWeight: 800,
            fontSize: 24,
            lineHeight: '135%',
            letterSpacing: '0.02em',
            marginBottom: 30,
        },
        '> .personalized-body': {
            [mobileOnly]: {
                boxShadow: '0px 2px 8px rgba(21, 32, 107, 0.05)',
            },
        },

        '.personalized-body': {
            backgroundColor: colors.WHITE,
            borderRadius: 7,
            marginBottom: 20,
            position: 'relative',

            '.icon-star': {
                position: 'absolute',
                top: 30,
                left: 20,

                [tabletLandscapeUp]: {
                    top: '35px !important',
                    left: '25px !important',
                },
            },
            '.toggle': {
                border: 'none',
                width: '100%',
                background: 'none',
                color: colors.BLUE,
            },
            '.personalized-subheader': {
                display: 'flex',
                justifyContent: 'space-between',
                [mobileOnly]: {
                    padding: '24px 19px 21px 24px',
                    flexDirection: 'column',
                    alignItems: 'baseline',
                },
                [tabletPortraitUp]: {
                    padding: '24px 19px 21px 24px',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                },
                [tabletLandscapeUp]: {
                    padding: '25px 30px',
                },
                '.personalized-product-total-count': {
                    '&.mobile': {
                        display: 'block',
                        [tabletPortraitUp]: {
                            display: 'none',
                        }
                    },
                    '&.desktop': {
                        display: 'none',
                        [tabletPortraitUp]: {
                            display: 'block',
                        }
                    },
                },
                '.choose-size': {
                    textDecoration: 'underline'
                },
                '.personalized-info': {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignContent: 'center',
                    flexDirection: 'row',
                    marginLeft: 20,
                    [mobileOnly]: {
                        width: '100%',
                    },
                    '.personalized-info-name': {
                        color: colors.NAVY,
                        fontWeight: 800,
                        fontSize: 21,
                        lineHeight: '135%',
                        letterSpacing: '0.02em',
                        marginRight: 18,
                        marginLeft: 10,
                    },
                    '.icon-dropdown': {
                        marginRight: 28,
                        [mobileOnly]: {
                            marginRight: 20,
                        },
                    },
                    '.personalized-prices': {
                        display: 'flex',
                        flexDirection: 'row',
                        marginRight: 18,
                        alignItems: 'center',
                        '.total': {
                            marginLeft: 8,
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            fontSize: 15,
                            lineHeight: '135%',
                            color: colors.GREEN_BRIGHT
                        },
                        '.subtotal': {
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            fontSize: 15,
                            lineHeight: '135%',
                            textDecorationLine: 'line-through',
                            color: colors.BLUE
                        },
                        '.personalized-product-total-count': {
                            marginLeft: 8,
                        },
                        '.no-discount-total': {
                            marginLeft: 8,
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                            fontSize: 15,
                            lineHeight: '135%',
                            color: colors.BLUE
                        }

                    }
                },
                '.personalized-action': {
                    display: 'flex',
                    alignItems: 'center',

                    button: {
                        width: 188,
                        '&.green': {
                            background: 'rgba(201, 229, 222, 1)',
                            color: 'white',
                        }
                    },
                }
            },
            '.personalized-products-wrapper': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderTop: `1px solid ${colors.BLUE_EXTRA_LIGHT}`,
                borderBottom: `1px solid ${colors.BLUE_EXTRA_LIGHT}`,
                [mobileOnly]: {
                    flexWrap: 'wrap',
                    gap: 4,
                    padding: '10px 0',
                },
                [tabletPortraitUp]: {
                    flexWrap: 'wrap',
                    gap: 4,
                    padding: '10px 0',
                },
                [tabletLandscapeUp]: {
                    flexWrap: 'nowrap',
                    gap: 0,
                    padding: '10px 0',
                },

                '.personalized-products': {
                    maxWidth: 147,
                    width: '100%',
                    position: 'relative',

                    '&:last-child': {
                        [mobileOnly]: {

                        },
                        [tabletPortraitUp]: {

                        },
                        [tabletLandscapeUp]: {
                            marginRight: 0,
                        },
                        [desktopUp]: {

                        },
                    },
                    '.product': {
                        position: 'relative',

                        '.title, .new-info, .out-of-stock-info, .recommended-info, .peppa-pig, .info, .star-wrapper': {
                            display: 'none',
                        },
                        '.image': {
                            'img, picture': {
                                display: 'block',
                                maxWidth: '100%',
                                height: 'auto',
                            }
                        },
                        '.out-of-stock-button': {
                            display: 'none'
                        }
                    },
                    '.product-count': {
                        position: 'absolute',
                        minWidth: 34,
                        height: 30,
                        bottom: 9,
                        right: 9,
                        color: colors.WHITE,
                        backgroundColor: colors.BLUE,
                        border: `1px solid ${colors.WHITE}`,
                        borderRadius: 5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 13,
                        lineHeight: '135%',
                        letterSpacing: '0.01em',
                    },

                    [mobileOnly]: {
                        maxWidth: '32%',
                    },
                    [tabletPortraitUp]: {
                        flexWrap: 'wrap',
                    },
                    [tabletLandscapeUp]: {
                        flexWrap: 'nowrap',
                        marginRight: 4,
                    },
                }
            },
            '.personalized-products-info': {
                padding: 29,
                borderBottom: `1px solid ${colors.BLUE_EXTRA_LIGHT}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                [mobileOnly]: {
                    padding: '45px 20px 33px 20px',
                    flexDirection: 'column',
                    borderBottom: 'none',
                },
                'p': {
                    color: colors.NAVY,
                    fontWeight: 'normal',
                    fontSize: 15,
                    lineHeight: '145%',
                    letterSpacing: '0.02em',
                    marginBottom: 0,
                    [mobileOnly]: {
                        order: 2,
                        marginTop: 45,
                        textAlign: 'center',
                    },
                },
                '.personalized-info-actions': {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    [mobileOnly]: {
                        order: 1,
                    },

                    'span': {
                        display: 'flex',
                        alignItems: 'center',
                        color: colors.BLUE,
                        fontWeight: 'bold',
                        fontSize: 15,
                        lineHeight: '19px',
                        letterSpacing: '0.01em',
                        marginRight: 32,
                        '&:last-child': {
                            marginRight: 0,
                        },
                        'img': {
                            marginRight: 12,
                            cursor: 'pointer'
                        }
                    }
                }
            },
            'button.desktop': {
                display: 'none',
                [tabletLandscapeUp]: {
                    display: 'block',
                },
            },
            'button.mobile': {
                display: 'block',
                maxWidth: 283,
                width: '100%',
                margin: '0 auto',
                marginTop: 15,
                [tabletLandscapeUp]: {
                    display: 'none',
                },
            },
        },
    })
};
